import { render, staticRenderFns } from "./v_Admin_DiscountCoupons.vue?vue&type=template&id=4e214580&scoped=true&"
import script from "./v_Admin_DiscountCoupons.vue?vue&type=script&lang=js&"
export * from "./v_Admin_DiscountCoupons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e214580",
  null
  
)

export default component.exports